// extracted by mini-css-extract-plugin
export var list = "owners-module--list--1kIZL";
export var item = "owners-module--item--2dFq0";
export var title = "owners-module--title--1igpC";